module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"title":"Products","new_resource":"New Product"},"pt-BR":{"title":"Produtos","new_resource":"Novo Produto"}}')
  delete Component.options._Ctor
}
